'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message2 = require('linksoft/message');

var _message3 = _interopRequireDefault(_message2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var common = {
    createElement: function createElement(tagName, parentElement, params) {
        // Create element helper, to simplify this process
        if (!tagName || !parentElement) return null;

        var element = document.createElement(tagName);
        if (params) {
            Object.assign(element, params);
        }
        parentElement.appendChild(element);
        return element;
    },
    getCartData: function getCartData() {
        try {
            var storeData = _store2.default.get();
            return storeData.getState().cart;
        } catch (e) {
            console.error('Cart state was not loaded.', e);
            return null;
        }
    },
    sortByStringParam: function sortByStringParam(array, paramName) {
        var collator = Intl.Collator();

        return array.sort(function (a, b) {
            return collator.compare(a[paramName], b[paramName]);
        });
    },
    replaceDiacriticsCharacters: function replaceDiacriticsCharacters(inputString) {
        var diacriticsChars = "áäčďéěíĺľňóôőöŕšťúůűüýřžÁÄČĎÉĚÍĹĽŇÓÔŐÖŔŠŤÚŮŰÜÝŘŽ";
        var replacements = "aacdeeillnoooorstuuuuyrzAACDEEILLNOOOORSTUUUUYRZ";
        var result = '';
        for (var p = 0; p < inputString.length; p++) {
            var currentChar = inputString.charAt(p);
            var charIndex = diacriticsChars.indexOf(currentChar);
            result += charIndex !== -1 ? replacements.charAt(charIndex) : currentChar;
        }
        return result;
    },
    showMessageOrNotify: function showMessageOrNotify(severity, showAsPopup, title, messageText, options) {
        switch (severity.toLowerCase()) {
            case 'warn':
            case 'warning':
                if (showAsPopup) _message3.default.warn(messageText, title, options);else _notify2.default.warn(messageText, title, options);
            case 'err':
            case 'error':
            default:
                if (showAsPopup) _message3.default.error(messageText, title, options);else _notify2.default.error(messageText, title, options);
        }
    },

    batchReplace: function batchReplace(originalText, replacementObject) {
        if (!originalText || !replacementObject || !Array.isArray(replacementObject)) return originalText;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = replacementObject[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var replacement = _step.value;

                originalText = originalText.replaceAll(replacement.original, replacement.replacement);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return originalText;
    },
    hasMarketingConsent: function hasMarketingConsent() {
        return common.getCookieConsent().marketing === 'true';
    },
    getElementPropertySafe: function getElementPropertySafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

        var element = document.querySelector(selector);
        return element ? element[propertyName] : null;
    },
    setElementPropertySafe: function setElementPropertySafe(selector) {
        var propertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var element = document.querySelector(selector);
        if (!element) return null;
        element[propertyName] = propertyValue;
        return element;
    },
    setElementDatasetValueSafe: function setElementDatasetValueSafe(selector) {
        var dataSetPropertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
        var propertyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var element = document.querySelector(selector);
        if (!element) return null;
        element.dataset[dataSetPropertyName] = propertyValue;
        return element;
    },
    setListenerSafe: function setListenerSafe(selector, delegate) {
        var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'click';

        var element = document.querySelector(selector);
        if (!element) return null;
        element.addEventListener(eventType, delegate);
        return element;
    },

    findDeliveryRefSafe: function findDeliveryRefSafe(cart, key) {
        if (!cart || !cart.constants) return '';
        var constantObject = cart.constants.find(function (i) {
            return i.key === key;
        });
        if (!constantObject) return '';
        return constantObject.value;
    },
    reverseString: function reverseString(str) {
        return str.split("").reverse().join("");
    },

    addRemoveClass: function addRemoveClass(selector, className, isAdd) {
        var errorOnNoElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        var element = document.querySelector(selector);
        if (!element) {
            if (errorOnNoElement) console.error('Error in common/addRemoveClass', { selector: selector, className: className, isRemove: isAdd });
            return;
        }
        if (isAdd) element.classList.add(className);else element.classList.remove(className);
    },
    convertIntSafe: function convertIntSafe(value) {
        if (!value || typeof value !== 'string') return 0;
        return (/^-?[0-9]{1,10}$/.test(value) ? parseInt(value) : 0
        );
    },
    roundToDecimalPlaces: function roundToDecimalPlaces(value) {
        var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        try {
            if (typeof value !== 'number') {
                console.error('Passed value: \'' + value + '\' is not a number, which can be rounded.');
                return value;
            }
            var multiplier = Math.pow(10, decimalPlaces);
            return Math.round(value * multiplier) / multiplier;
        } catch (e) {
            console.error('Error rounding to specified decimal places of passed value: \'' + value + '\'.', e);
            return value;
        }
    },
    updateValidityView: function updateValidityView(validationText, validatedElement, additionalClass) {
        var warningElement = validatedElement.parentElement.querySelector('.field-validation-error');
        // empty text or null means validation passed, if text is present, processing continues
        if (!validationText) {
            validatedElement.classList.remove('input-validation-error');
            if (warningElement) warningElement.parentElement.removeChild(warningElement);
            return;
        }

        // show result in case of validation text is present
        if (warningElement) {
            warningElement.textContent = validationText;
        } else {
            common.createElement('span', validatedElement.parentElement, {
                className: 'field-validation-error text-danger ' + additionalClass, textContent: validationText
            });
        }
        validatedElement.classList.add('input-validation-error');
    },

    registerRegexValidation: function registerRegexValidation(element, pattern, validationMessage) {
        if (!element) {
            console.warn('Element assigned for validation (registerRegexValidation) has empty element: ' + element);
            return;
        }
        pattern = pattern || element.dataset.valRegexPattern;
        if (!pattern) {
            console.warn('Element assigned for validation has empty pattern: ' + pattern);
            return;
        }

        element.addEventListener('keyup', function (event) {
            try {
                var regex = new RegExp(pattern);
                var isInvalid = element.dataset.isInvalid = !regex.test(element.value);
                var _message = isInvalid ? validationMessage || element.dataset.msg : null;
                // create element and set class
                common.updateValidityView(_message, element);
            } catch (e) {
                console.error('Error in validation (registerRegexValidation). Element: ' + element + ', pattern: ' + pattern);
            }
        });
    }
};

exports.default = common;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/common.js
// module id = 81
// module chunks = 0